// require.ensure 是 Webpack 的特殊语法，用来设置 code-split point
import Main from './views/Main.vue';
const Home = resolve => {
    require.ensure(['./views/Home.vue'], () => {
        resolve(require('./views/Home.vue'));
    });
};

const BookList = resolve => {
    require.ensure(['./views/book/list.vue'], () => {
        resolve(require('./views/book/list.vue'));
    });
};

const AddBook = resolve => {
    require.ensure(['./views/book/add.vue'], () => {
        resolve(require('./views/book/add.vue'));
    });
};
const AddSong = resolve => {
    require.ensure(['./views/song/add.vue'], () => {
        resolve(require('./views/song/add.vue'));
    });
};
const SongList = resolve => {
    require.ensure(['./views/song/list.vue'], () => {
        resolve(require('./views/song/list.vue'));
    });
};
const SongInfo = resolve => {
    require.ensure(['./views/song/info.vue'], () => {
        resolve(require('./views/song/info.vue'));
    });
};
const AddTeacher = resolve => {
    require.ensure(['./views/teacher/add.vue'], () => {
        resolve(require('./views/teacher/add.vue'));
    });
};
const TeacherList = resolve => {
    require.ensure(['./views/teacher/list.vue'], () => {
        resolve(require('./views/teacher/list.vue'));
    });
};
const TeacherInfo = resolve => {
    require.ensure(['./views/teacher/info.vue'], () => {
        resolve(require('./views/teacher/info.vue'));
    });
};
const TaskList = resolve => {
    require.ensure(['./views/task/list.vue'], () => {
        resolve(require('./views/task/list.vue'));
    });
};
const RoomMsg = resolve => {
    require.ensure(['./views/room/msg.vue'], () => {
        resolve(require('./views/room/msg.vue'));
    });
};
const RoomList = resolve => {
    require.ensure(['./views/room/roomList.vue'], () => {
        resolve(require('./views/room/roomList.vue'));
    });
};
const QRCodeList = resolve => {
    require.ensure(['./views/tools/qrcode.vue'], () => {
        resolve(require('./views/tools/qrcode.vue'));
    });
};
const BannerList = resolve => {
    require.ensure(['./views/banner/list.vue'], () => {
        resolve(require('./views/banner/list.vue'));
    });
};
const PictureList = resolve => {
    require.ensure(['./views/picture/list.vue'], () => {
        resolve(require('./views/picture/list.vue'));
    });
};
const JPushAdd = resolve => {
    require.ensure(['./views/push/add.vue'], () => {
        resolve(require('./views/push/add.vue'));
    });
};

const routers = [{
    path: '/',
    component: Home,
    name: '首页',
    iconCls: 'el-icon-setting',
    meta: { requiresAuth: false },
    children: [
        { path: '/main', component: Main, name: '主页', hidden: true }
    ]
}, {
    path: '/',
    component: Home,
    name: '曲库管理',
    iconCls: 'el-icon-message',
    meta: { requiresAuth: true, authName: 'bookIndex' },
    children: [
        { path: '/book/add', component: AddBook, name: '添加教材', meta: { requiresAuth: true, authName: 'bookAdd' } },
        { path: '/book/list', component: BookList, name: '教材列表', meta: { requiresAuth: true, authName: 'bookList' } },
        { path: '/song/add/:bId', component: AddSong, hidden: true, name: '添加曲目', meta: { requiresAuth: true, authName: 'songAdd' } },
        { path: '/song/info/:bId/:sId', component: SongInfo, hidden: true, name: '曲目信息', meta: { requiresAuth: true, authName: 'songInfo', backInfo: { backName: '返回曲目管理', backUrl: '' } } },
        { path: '/song/list/:bId', component: SongList, hidden: true, name: '曲目列表', meta: { requiresAuth: true, authName: 'songList', backInfo: { backName: '返回教材管理', backUrl: '/book/list' } } }
    ]
}, {
    path: '/',
    component: Home,
    name: '名师管理',
    iconCls: 'el-icon-star-on',
    meta: { requiresAuth: true, authName: 'tchIndex' },
    children: [
        { path: '/teacher/add', component: AddTeacher, name: '添加名师', meta: { requiresAuth: true, authName: 'tchAdd' } },
        { path: '/teacher/list', component: TeacherList, name: '名师列表', meta: { requiresAuth: true, authName: 'tchList' } },
        { path: '/teacher/info/:tchId', component: TeacherInfo, hidden: true, name: '名师信息', meta: { requiresAuth: true, authName: 'tchInfo', backInfo: { backName: '返回名师管理', backUrl: '/teacher/list' } } }
    ]
}, {
    path: '/',
    component: Home,
    name: '广告位管理',
    iconCls: 'el-icon-star-on',
    meta: { requiresAuth: true, authName: 'bannerIndex' },
    leaf: true,
    children: [
        { path: '/banner/list', component: BannerList, name: '广告位信息', meta: { requiresAuth: true, authName: 'bannerList' } }
    ]
}, {
    path: '/',
    component: Home,
    name: '图片管理',
    iconCls: 'el-icon-star-on',
    meta: { requiresAuth: true, authName: 'pictureIndex' },
    leaf: true,
    children: [
        { path: '/picture/list', component: PictureList, name: '图片信息', meta: { requiresAuth: true, authName: 'pictureList' } }
    ]
}, {
    path: '/',
    component: Home,
    name: '推送管理',
    iconCls: 'el-icon-star-on',
    meta: { requiresAuth: true, authName: 'jpushIndex' },
    leaf: true,
    children: [
        { path: '/jpush/add', component: JPushAdd, name: '推送信息', meta: { requiresAuth: true, authName: 'jpushAdd' } }
    ]
}, {
    path: '/',
    component: Home,
    name: '任务管理',
    iconCls: 'el-icon-time',
    meta: { requiresAuth: true, authName: 'taskIndex' },
    leaf: true,
    children: [
        { path: '/task/list', component: TaskList, name: '任务列表', meta: { requiresAuth: true, authName: 'taskList' } }
    ]
}, {
    path: '/',
    component: Home,
    name: '在线教室管理',
    iconCls: 'el-icon-document',
    meta: { requiresAuth: true, authName: 'roomIndex' },
    children: [
        { path: '/room/message', component: RoomMsg, name: '消息统计', meta: { requiresAuth: true, authName: 'roomMsg' } },
        { path: '/room/list', component: RoomList, name: '教室列表', meta: { requiresAuth: true, authName: 'roomList' } }
    ]
}, {
    path: '/',
    component: Home,
    name: '系统工具',
    iconCls: 'el-icon-information',
    meta: { requiresAuth: true, authName: 'toolIndex' },
    children: [
        { path: '/tool/qrcode', component: QRCodeList, name: '二维码管理', meta: { requiresAuth: true, authName: 'toolQRCode' } }
    ]
}, {
    path: '/login',
    name: '登录',
    hidden: true,
    component(resolve) {
        require.ensure(['./views/Login.vue'], () => {
            resolve(require('./views/Login.vue'));
        });
    }
}, {
    path: '*',
    hidden: true,
    component: Home
}];

export default routers;



// WEBPACK FOOTER //
// ./src/routers.js